import { render, staticRenderFns } from "./MenuButtons.vue?vue&type=template&id=5c3d588f&"
import script from "./MenuButtons.vue?vue&type=script&lang=js&"
export * from "./MenuButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports